import React from 'react';
import styled from 'styled-components';

const Wrapper = styled.div`
  border: 1px solid #d1d5da;
  border-radius: 6px;

  pre {
    margin: 1em;
  }
`;

const Docker = ({ name, description, icon, color, repo }) => (
  <Wrapper>
    <pre>
{`LABEL "com.github.actions.name" = "${name}"
LABEL "com.github.actions.description" = "${description}"
LABEL "com.github.actions.icon" = "${icon}"
LABEL "com.github.actions.color" = "${color}"

LABEL "repository" = "${repo}"
LABEL "homepage" = "${repo}"`}
</pre>
  </Wrapper>
);

export default Docker;
